<app-breadcrumb *ngIf="!newsletter" [parentName]="'Newsletter'" [name]="'Dodaj'"></app-breadcrumb>
<div class="newsletter-add" fxLayout="column" fxLayoutGap="15px" [formGroup]="documentForm">
  <div *ngIf="!dialogRef" fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!documentForm.valid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxLayout="column" [fxFlex]="dialogRef ? '100' : '50'" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane pliku</h3>
            </div>
            <div fxLayout="row">

              <ng-container *ngIf="!newsletter"></ng-container>
              <app-file-drag-and-drop  fxFlex="100"
                                      [multiple]="false"
                                      [generateOutput]="true"
                                      [maxSize]=fileMaxSize
                                      (fileSelected)="fileSelected($event)"
                                      [fileControl]="fileControl"
              ></app-file-drag-and-drop>

            </div>

            <div fxLayout="row">
              <mat-form-field fxFlex="100">
                <mat-label>Nazwa</mat-label>
                <input matInput placeholder="Nazwa" [formControl]="newsletterNameControl" [required]="true">
                <mat-error *ngIf="newsletterNameControl.hasError('required')">To pole jest wymagane</mat-error>
              </mat-form-field>
            </div>

          </mat-card>
        </div>
      </div>

    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!documentForm.valid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
